
export const ReviewInitialValues = (showData) => ({
  from_user_id: showData?.data?.from_user_id || "",
  to_user_id: showData?.data?.to_user_id || "",
  rating: showData?.data?.rating || "",
  comment: showData?.data?.comment || "",
});
